import { useMutation } from '@tanstack/react-query'
import { deployApi } from '../api/deploy'
import type { DeploymentSuggestionRequest } from '../types/deploy'

/**
 * Hook for getting AI-powered deployment suggestions.
 *
 * Uses a mutation (not query) because it's triggered on-demand
 * and the parameters change with each request.
 */
export function useDeploymentSuggestions() {
  return useMutation({
    mutationFn: (request: DeploymentSuggestionRequest) =>
      deployApi.getSuggestions(request),
  })
}
